<template>
  <PagesCrud
    :config="config"
    :selectedLang="selectedLang"
    
    @config="conf => $emit('config', conf)"
    @on-save="func => $emit('on-save', func)"
    @remove-on-save="func => $emit('remove-on-save', func)"
  />
</template>

<script>

import PagesCrud from "../../../pages/websites/WebsiteTabs/WebsiteContents/PagesCrud.vue"

export default {
  components: {
    PagesCrud,
  },
  props: {
    config: Object,
    selectedLang: String,
  },
}

</script>
